// PSRL Transfer Rules API Service - Points Sharing Rules (Spec Compliant)

import axios from "axios";
import { BASE_URL } from '../../../../Constants/EnvironmentVariableProvider';

const TRANSFER_RULES_API = "PSRLTransferRules/";

// 1. Get All Rules
export async function getAllRules(page = 1, pageSize = 50, searchTerm = "", agencyId = null, agentId = null, fromDate = null, toDate = null, selectedStatus) {
  const params = { page, pageSize };
  if (searchTerm) params.searchTerm = searchTerm;
  if (agencyId) params.agencyId = agencyId;
  if (agentId) params.agentId = agentId;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (selectedStatus) params.status = selectedStatus;



  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}GetAllRules`,
    { params }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch Points Sharing Rules");
  return result.data;
}

// 2. Get Rule by ID
export async function getRuleById(ruleId) {
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}GetRuleById`,
    { params: { ruleId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch Points Sharing Rule");
  return result.data;
}

// 3. Create Rule
export async function createRule(ruleData) {
  const res = await axios.post(
    `${BASE_URL}${TRANSFER_RULES_API}CreateRule`,
    ruleData
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to create Points Sharing Rule");
  return result;
}

// 4. Update Rule
export async function updateRule(ruleData) {
  const res = await axios.put(
    `${BASE_URL}${TRANSFER_RULES_API}UpdateRule`,
    ruleData
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to update Points Sharing Rule");
  return result;
}

// 5. Delete Rule
export async function deleteRule(ruleId) {
  const res = await axios.delete(
    `${BASE_URL}${TRANSFER_RULES_API}DeleteRule`,
    { params: { ruleId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to delete Points Sharing Rule");
  return result;
}

// 6. Get Agencies
export async function getAgencies(searchTerm = "") {
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}GetAgencies`,
    { params: { searchTerm } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch agencies");
  return result.data;
}

// 7. Get Agents
export async function getAgents(searchTerm = "", agencyId = null) {
  const params = { searchTerm };
  if (agencyId) {
    params.agencyId = agencyId;
  }
  
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}GetAgents`,
    { params }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch agents");
  return result.data;
}

// 8. Check for overlapping dates
export async function checkOverlappingDates(agencyId, fromDate, toDate, excludeRuleId = null) {
  const params = { agencyId };
  if (fromDate) {
    params.fromDate = fromDate;
  }
  if (toDate) {
    params.toDate = toDate;
  }
  if (excludeRuleId) {
    params.excludeRuleId = excludeRuleId;
  }
  
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}CheckOverlappingDates`,
    { params }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to check overlapping dates");
  return result.data;
}

// 9. Check for transfers outside date range
export async function checkTransfersOutsideDateRange(ruleId, fromDate, toDate) {
  const params = { ruleId };
  if (fromDate) {
    params.fromDate = fromDate;
  }
  if (toDate) {
    params.toDate = toDate;
  }
  
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}CheckTransfersOutsideDateRange`,
    { params }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to check points transfers outside date range");
  return result.data;
}

// 10. Get transfers by rule ID
export async function getTransfersByRuleId(ruleId) {
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}GetTransfersByRuleId`,
    { params: { ruleId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch points transfers for rule");
  return result.data;
}

// 11. Reverse rule
export async function reverseRule(ruleId) {
  const res = await axios.post(
    `${BASE_URL}${TRANSFER_RULES_API}ReverseRule`,
    null,
    { params: { ruleId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to reverse Points Sharing Rule");
  return result;
}

// 12. Check if rule has transactions
export async function checkRuleHasTransactions(ruleId) {
  try {
    const transfers = await getTransfersByRuleId(ruleId);
    return {
      hasTransactions: transfers && transfers.length > 0,
      transactionCount: transfers ? transfers.length : 0
    };
  } catch (err) {
    console.error('Error checking rule transactions:', err);
    return { hasTransactions: false, transactionCount: 0 };
  }
}

// 13. Get affected submissions by rule ID
export async function getAffectedSubmissions(ruleId) {
  const res = await axios.get(
    `${BASE_URL}${TRANSFER_RULES_API}GetAffectedSubmissions`,
    { params: { ruleId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch affected submissions");
  return result.data;
}

// 14. Deactivate rule
export async function deactivateRule(ruleId) {
    const res = await axios.post(
    `${BASE_URL}${TRANSFER_RULES_API}DeactivateRule`,
    null,
    { params: { ruleId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to deactivate rule");
  return result;
}
